import { API_BASE_URL, API_GET_DEPARTMENT } from "../../../utils/API_CONSTANTS";
import { useDispatch, useSelector } from 'react-redux';
import { setDepartment, setDepartmentFound, setRemainingDepartment, setDepartmentId } from "../../../state";

// Modify the findDepartment function to handle the special case for roll number starting with "2051"
const findDepartment = (dispatch, data, userRollNumber) => {
  // Check if rollNoPrefix starts with '2051'
  if (userRollNumber.toString().startsWith("2051")) {
    // Directly return the ID for this specific roll prefix
    return "61ece7236aa1d0952ea23db1";
  }else if(userRollNumber.toString().startsWith("2091")){
    return "61ece7246aa1d0952ea23db5";
  }
 else if(userRollNumber.toString().startsWith("2151")){
    return "61ece7236aa1d0952ea23daf";
  }else if(userRollNumber.toString().startsWith("2041")){
    return "61ece7246aa1d0952ea23db7";
  }
  else if(userRollNumber.toString().startsWith("2053")){
    return "61ece7256aa1d0952ea23dbb";
  }

  let object = data.find(
    (item) =>
      item.rollNoPrefix === userRollNumber.toString().substring(0, 4)
  );

  if (object === undefined || !object._id) {
    // If the department is not found, dispatch actions accordingly
    // dispatch(setDepartmentFound(false));
    // dispatch(setRemainingDepartment(data));
    return "61ece7256aa1d0952ea23dbb"
  } else {
    return object._id;
  }
};

export const getDepartmentAPI = async (dispatch, userRollNumber) => {
  try {
    const response = await fetch(API_BASE_URL + API_GET_DEPARTMENT);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
  
    // Get the department ID by calling findDepartment
    const deptId = findDepartment(dispatch, data.result, userRollNumber);
    return deptId;
  } catch (error) {
    // Handle errors here
    console.error('Error fetching department:', error);
  }
};

export const useDepartment = () => {
  const dispatch = useDispatch();
  const userRollNumber = useSelector((state) => state.auth.user?.rollNoPrefix);

  return { getDepartmentAPI: () => getDepartmentAPI(dispatch, userRollNumber) };
};
